import axios, { AxiosResponse } from "axios";
import { createGranularRequestConfig } from "@granular/fabric-catalog-helpers";
import { User, PutUser, GetUser } from "./schemas";

const GET = async ({
  userRequestConfig,
  axiosRequestConfig,
  domain = "",
}: GetUser): Promise<AxiosResponse<User>> => {
  const response = await axios.get(
    `${domain}/api/user-svc/me`,
    createGranularRequestConfig(userRequestConfig, { axiosRequestConfig }),
  );
  return response;
};

const PUT = async ({
  user,
  userRequestConfig,
  axiosRequestConfig,
  domain = "",
}: PutUser): Promise<AxiosResponse<User>> => {
  const response = await axios.put(
    `${domain}/api/user-svc/me`,
    user,
    createGranularRequestConfig(userRequestConfig, { axiosRequestConfig }),
  );
  return response;
};

export default {
  GET,
  PUT,
};
